(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[821],{

/***/ 92427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Software; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/cities_content/StockBrokerListing.tsx







function OtherCitiesList(_ref) {
  var allCities = _ref.allCities;
  var Title = typography/* default.Title */.Z.Title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          level: 2,
          children: "Cities List for Stock Brokers"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      gutter: [16, 24],
      children: allCities.map(function (cityObj, idx) {
        var _cityObj$attributes = cityObj.attributes,
            city = _cityObj$attributes.name,
            state = _cityObj$attributes.state;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          className: "gutter-row",
          xs: 12,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/brokers/[city]/[state]",
            as: "/brokers/".concat(city, "/").concat(state),
            children: "".concat((0,util/* unslugify */.BW)(city), ", ").concat((0,util/* unslugify */.BW)(state))
          }, idx)
        }, idx);
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/cities_content/index.js




function CitiesContent(_ref) {
  var allCities = _ref.allCities;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    className: "page-wrapper page",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      xs: 24,
      md: 20,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OtherCitiesList, {
        allCities: allCities
      })
    })
  });
}
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
;// CONCATENATED MODULE: ./pages/cities.tsx






var title = "Stock Brokers";
var description = "Stock Brokers";
var __N_SSG = true;
function Software(props) {
  var pageData = props.data;
  var allBrokers = pageData.all_brokers.data,
      navCalculators = pageData.all_calculators.data,
      allCities = pageData.all_cities.data,
      allPages = pageData.all_pages.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers,
    navCalculators: navCalculators,
    allPages: allPages,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CitiesContent, {
      allCities: allCities
    })]
  });
}

/***/ }),

/***/ 8613:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cities",
      function () {
        return __webpack_require__(92427);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,8182,9774,2888,179], function() { return __webpack_exec__(8613); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);